
import React, {useEffect, useState } from "react";
import Moment from 'react-moment';
import moment from 'moment';
import Button from '@mui/material/Button';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import Typography from '@mui/material/Typography';
//import DateTimePicker from '@mui/lab/DateTimePicker';
import AdapterDateFns from '@mui/lab/AdapterDateFns';
import LocalizationProvider from '@mui/lab/LocalizationProvider';
import MobileDateTimePicker from '@mui/lab/MobileDateTimePicker'
import TextField from '@mui/material/TextField';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import generatePDFParking from "../services/reportGeneratorParking";
import BeatLoader from "react-spinners/BeatLoader";
import authHeader from "../services/auth-header";
import AuthService from "../services/auth.service";
//import { Link } from 'react-router-dom';
import { useParams } from "react-router-dom";
//import DetectorsByParking from '../detectors/DetectorsByParking';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';

import { useTranslation } from "react-i18next";

const api = require("../api/names.js");

function ParkingErrors() {

    const { t } = useTranslation("common");

    const [error, setError] = useState(null);
    const [isLoaded, setIsLoaded] = useState(false);
    const [userId, setUserId] = useState(true);
    const [generating, setGenerating] = useState(0);
    //const [itemsParkingStatsOccupancy, setItemsParkingStatsOccupancy] = useState([]);
    const [dateMin, setDateMin] = useState(new Date(Date.now() - (1 * 24 * 60 * 60 * 1000)));
    const [dateMax, setDateMax] = useState(new Date());
    const [itemsTime, setItemsTime] = useState([]);
    const [itemsBattery, setItemsBattery] = useState([]);
    const [addressTable, setAddressTable] = useState({});
    const [historyData, setHistoryData] = useState([]);
    const [rowsNumber, setRowsNumber] = useState(0);

    const params = useParams();
    console.log(params);

    useEffect(() => {
        const user = AuthService.getCurrentUser();
        if(user)
        {
            setUserId(user.id);
            loadCurrentErrors(user.id);
            setIsLoaded(true);
        }
        else
        {
            setIsLoaded(true);
            setError({message:"No user"});
        }

    }, [])

    function loadCurrentErrors(user) {
        var url;
        if (user === 4) {
            url = api.baseUrl + '/detectorsCurrentValues/';
            //url += user.id;//params.userID;//currentUser.id;//props.userID;
        }
        else {
            url = api.baseUrl + '/detectorsCurrentValues/byUserID/';
            url += user;//params.userID;//currentUser.id;//props.userID;
        }
        //console.log(url);
        fetch(url, {
            method: 'get',
            headers: authHeader()
        })
            .then(res => res.json())
            .then(
                (result) => {
                    console.log(result);
                    setItemsBattery(result.filter(item => item.battery <= 100));
                    setItemsTime(result.filter(item => (item.timestamp / 1000) < (Math.round(moment().unix()) - 86400)));
                    setRowsNumber(result.length);
                    var addresses = ([]);
                    for (var i = 0; i < result.length; i++) {
                        addresses[i] = result[i].address;
                    }
                    setAddressTable(addresses);
                },
                (error) => {
                    setIsLoaded(true);
                    setError(error);
                }
            )
/*
        url = 'http://176.107.133.68:1880/historyLastTwo?start=' + dateMin.getTime() + '&stop=' + dateMax.getTime() +'&userID='+user;

        fetch(url, {
            method: 'get',
        })
            .then(res => res.json())
            .then(
                (result) => {
                    console.log(result);
                    setHistoryData(result);
                },
                (error) => {
                    setIsLoaded(true);
                    setError(error);
                }
            )*/
    }

    function loadHistoricalData(user)
    {
        var url = 'http://176.107.133.68:1880/historyLastTwo?start=' + dateMin.getTime() + '&stop=' + dateMax.getTime() + '&userID=' + user;

        fetch(url, {
            method: 'get',
        })
            .then(res => res.json())
            .then(
                (result) => {
                    setHistoryData(result);
                },
                (error) => {
                    setIsLoaded(true);
                    setError(error);
                }
            )
    }

    function changeGenerating() {
        setGenerating(1);
        setTimeout(() => {
            setGenerating(0);
        }, 2000);
    }

    function seconds2time(seconds) {
        var hours = Math.floor(seconds / 3600);
        var minutes = Math.floor((seconds - (hours * 3600)) / 60);
        seconds = Math.floor(seconds - (hours * 3600) - (minutes * 60));
        var time = "";

        if (hours !== 0) {
            time = hours + "h ";
        }
        if (minutes !== 0 || time !== "") {
            minutes = (minutes < 10 && time !== "") ? "0" + minutes : String(minutes);
            time += minutes + "min ";
        }
        if (time === "") {
            time = seconds + "s";
        }
        else {
            time += (seconds < 10) ? "0" + seconds : String(seconds) + "s";
        }
        return time;
    }

    function historicalErrors(items,title) {
        return (
            <Accordion>
                <AccordionSummary
                    expandIcon={<ExpandMoreIcon />}
                    aria-controls="panel2a-content"
                    id="panel2a-header"
                >
                    <Typography>{title}</Typography>
                </AccordionSummary>
                <AccordionDetails>
                    <TableContainer component={Paper}>
                        <Table sx={{ minWidth: 650 }} aria-label="simple table">
                            <TableHead>
                                <TableRow>
                                    <TableCell>ID</TableCell>
                                    <TableCell>{t('charttable.id')}</TableCell>
                                    <TableCell >{t('parkingerrors.secondframe')}</TableCell>
                                    <TableCell >{t('parkingerrors.lastframe')}</TableCell>
                                    <TableCell >{t('parkingerrors.difference')}</TableCell>
                                    <TableCell >{t('parkingerrors.enddate')}</TableCell>
                                    <TableCell >{t('parkingerrors.warning')}</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {items.map((item) => (
                                    <TableRow
                                        key={item.address}
                                        sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                                    >
                                        <TableCell >{item.index}</TableCell>
                                        <TableCell >{item.address}</TableCell>
                                        <TableCell ><Moment format="HH:mm:ss - DD/MM/YYYY" unix>{item.second / 1000}</Moment></TableCell>
                                        <TableCell ><Moment format="HH:mm:ss - DD/MM/YYYY" unix>{item.first / 1000}</Moment></TableCell>
                                        <TableCell >{item.difference}</TableCell>
                                        <TableCell ><Moment format="HH:mm:ss - DD/MM/YYYY" unix>{item.date / 1000}</Moment></TableCell>
                                        <TableCell >{item.error}</TableCell>
                                    </TableRow>
                                ))}
                            </TableBody>
                        </Table>
                    </TableContainer>
                </AccordionDetails>
            </Accordion>
        )
    }

    function loadStatistics() {
        var itemsHistory = [], err0 = [], err1 =[], err2 = [], err3 = [], err4 = [];
        var temp, error, first, second, diff, addr;
        var j;
        var i;
        while (!isLoaded) {i++ };
        for(i = 0; i < rowsNumber; i++)
        {
            temp = 1;
            addr = addressTable[i];
            for (j = 0; j < historyData.length; j++)
            {
                if(addr === historyData[j].address)
                {
                    temp = 0;
                    break;
                }
            }
            if(temp)
            {
                error = t('parkingerrors.error.0');
                first = null;
                second = null;
                diff = null;
            }
            else
            {
                if (historyData[j].timestamp < historyData[j].timestamp_prev)
                {
                    first = historyData[j].timestamp_prev;
                    second = historyData[j].timestamp;
                }
                else
                {
                    first = historyData[j].timestamp;
                    second = historyData[j].timestamp_prev;
                }
                if (historyData[j].timestamp & historyData[j].timestamp_prev)
                {
                    error = t('parkingerrors.error.1')
                    diff = first - second;
                    if (diff > 24 * 60 * 60 * 1000)
                    {
                        error = t('parkingerrors.error.3')

                    }
                    if ((dateMax.getTime() - first) > 24 * 60 * 60 * 1000)
                        error = t('parkingerrors.error.4')
                }
                else
                {
                    diff = 0;
                    error = t('parkingerrors.error.2')
                    if ((dateMax.getTime() - first) > 24 * 60 * 60 * 1000)
                        error = t('parkingerrors.error.4')
                }
            }
            temp = {
                "index": null,
                "address": addr,
                "first": first,
                "second": second,
                "difference": seconds2time(diff/1000),
                "date": dateMax.getTime(),
                "error": error
            }
            if (error === t('parkingerrors.error.0'))
                err0.push(temp);
            else if (error === t('parkingerrors.error.1'))
                err1.push(temp);
            else if (error === t('parkingerrors.error.2'))
                err2.push(temp);
            else if (error === t('parkingerrors.error.3'))
                err3.push(temp);
            else if (error === t('parkingerrors.error.4'))
                err4.push(temp);
            itemsHistory.push(temp);
        }
        //itemsHistory = itemsHistory.sort((a, b) => (a.address > b.address) ? 1 : -1);
        //for (i = 1; i <= rowsNumber; i++) {
        //    itemsHistory[i-1].index = i;
        //}
        //console.log(itemsHistory);

        err0 = err0.sort((a, b) => (a.address > b.address) ? 1 : -1);
        for (i = 1; i <= err0.length; i++) {
            err0[i-1].index = i;
        }
        console.log(err0);

        err1 = err1.sort((a, b) => (a.address > b.address) ? 1 : -1);
        for (i = 1; i <= err1.length; i++) {
            err1[i - 1].index = i;
        }
        console.log(err1);

        err2 = err2.sort((a, b) => (a.address > b.address) ? 1 : -1);
        for (i = 1; i <= err2.length; i++) {
            err2[i - 1].index = i;
        }
        console.log(err2);

        err3 = err3.sort((a, b) => (a.address > b.address) ? 1 : -1);
        for (i = 1; i <= err3.length; i++) {
            err3[i - 1].index = i;
        }
        console.log(err3);

        err4 = err4.sort((a, b) => (a.address > b.address) ? 1 : -1);
        for (i = 1; i <= err4.length; i++) {
            err4[i - 1].index = i;
        }
        console.log(err4);

        var p_stats = {};
        var parkingStats = []
        p_stats.chart = 'div2PDF3';
        p_stats.id = 3;
        p_stats.dateMin= dateMin;
        p_stats.dateMax = dateMax;
        p_stats.parkingStats = parkingStats;
        console.log(p_stats);

        var data = {
            "time": itemsTime,
            "battery": itemsBattery,
            //"history": itemsHistory,
            "err0": err0,
            "err2": err2,
            "err3": err3,
            "err4": err4
        }
        p_stats.parkingStats.push(data);
        console.log(p_stats);

        return (
            <div>
                <br />
                <Button href='/parkings' variant="outlined" startIcon={<ArrowBackIcon />}>
                    {t('parkingd.comeback')}
                </Button>

                <button
                    className="btn btn-primary"
                    onClick={() => { changeGenerating(); generatePDFParking(p_stats) }}
                    disabled={generating}>
                    <BeatLoader loading={generating} size={15} color='#FFFFFF' />
                    {generating ? (t('parkingstats.generating')) : (t('parkingstats.report'))}
                </button>
                <br />
                <br />
               <LocalizationProvider dateAdapter={AdapterDateFns}>
                    <MobileDateTimePicker
                        ampm={false}
                        ampmInClock={false}
                        value={dateMin}
                        onChange={(newValue) => {
                            setDateMin(newValue);
                            //LoadHistoryData();
                            //console.log(dateMin);
                            //console.log(dateMin.getTime());

                        }}
                        label={t('parkingstats.begin')}
                        onError={console.log}
                        minDate={new Date('2018-01-01T00:00')}
                        inputFormat="yyyy/MM/dd HH:mm"
                        mask="___/__/__ __:__ _M"
                        renderInput={(params) => <TextField {...params} />}
                    />

                    <MobileDateTimePicker
                        ampm={false}
                        ampmInClock={false}
                        value={dateMax}
                        onChange={(newValue) => {
                            setDateMax(newValue);
                            //LoadHistoryData();
                        }}
                        label={t('parkingstats.end')}
                        onError={console.log}
                        minDate={new Date('2018-01-01T00:00')}
                        inputFormat="yyyy/MM/dd HH:mm"
                        mask="___/__/__ __:__ _M"
                        renderInput={(params) => <TextField {...params} />}
                    />


                </LocalizationProvider>
                <Button
                    onClick={() => {
                        loadHistoricalData(userId);
                    }}
                >
                    {t('charttable.loaddata')}
                </Button>
                <Button
                    onClick={() => {
                        //LoadDefaultHistoryData();
                    }}
                >
                    {t('charttable.resetdata')}
                </Button>
                <Accordion>
                    <AccordionSummary
                        expandIcon={<ExpandMoreIcon />}
                        aria-controls="panel2a-content"
                        id="panel2a-header"
                    >
                        <Typography>{t('parkingerrors.batterylow')}</Typography>
                    </AccordionSummary>
                    <AccordionDetails>
                        <TableContainer component={Paper}>
                            <Table sx={{ minWidth: 650 }} aria-label="simple table">
                                <TableHead>
                                    <TableRow>
                                        <TableCell>{t('charttable.id')}</TableCell>
                                        <TableCell >{t('detectord.battery')}</TableCell>
                                        <TableCell >{t('charttable.laststatus')}</TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {itemsBattery.map((item) => (
                                        <TableRow
                                            key={item.address}
                                            sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                                         >
                                            <TableCell >{item.address}</TableCell>
                                            <TableCell >{item.battery}</TableCell>
                                            <TableCell ><Moment format="HH:mm:ss - DD/MM/YYYY" unix>{item.timestamp/1000}</Moment></TableCell>
                                        </TableRow>
                                    ))}
                                </TableBody>
                            </Table>
                        </TableContainer>
                    </AccordionDetails>
                </Accordion>

                <Accordion>
                    <AccordionSummary
                        expandIcon={<ExpandMoreIcon />}
                        aria-controls="panel2a-content"
                        id="panel2a-header"
                    >
                        <Typography>{t('parkingerrors.longago')}</Typography>
                    </AccordionSummary>
                    <AccordionDetails>
                        <TableContainer component={Paper}>
                            <Table sx={{ minWidth: 650 }} aria-label="simple table">
                                <TableHead>
                                    <TableRow>
                                        <TableCell>{t('charttable.id')}</TableCell>
                                        <TableCell >{t('detectord.battery')}</TableCell>
                                        <TableCell >{t('charttable.laststatus')}</TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {itemsTime.map((item) => (
                                        <TableRow
                                            key={item.address}
                                            sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                                        >
                                            <TableCell >{item.address}</TableCell>
                                            <TableCell >{item.battery}</TableCell>
                                            <TableCell ><Moment format="HH:mm:ss - DD/MM/YYYY" unix>{item.timestamp/1000}</Moment></TableCell>
                                        </TableRow>
                                    ))}
                                </TableBody>
                            </Table>
                        </TableContainer>
                    </AccordionDetails>
                </Accordion>
                <Accordion>
                    <AccordionSummary
                        expandIcon={<ExpandMoreIcon />}
                        aria-controls="panel2a-content"
                        id="panel2a-header"
                    >
                        <Typography>{t('parkingerrors.historicaldata')}</Typography>
                    </AccordionSummary>
                    <AccordionDetails>
                        {historicalErrors(err0, t('parkingerrors.description.0'))}
                        {historicalErrors(err2, t('parkingerrors.description.1'))}
                        {historicalErrors(err3, t('parkingerrors.description.2'))}
                        {historicalErrors(err4, t('parkingerrors.description.3'))}
                        {historicalErrors(err1, t('parkingerrors.description.4'))}
                    </AccordionDetails>
                </Accordion>
                {rowsNumber+' '+t('parkingerrors.sensors')}
                <div id="div2PDF3" style={{ display: "none" }} >
                    {"temp"}
                </div>
            </div>

        )

    }


    if (error) {
        return <div>{t('detectord.error')}{error.message}</div>;
    } else if (!isLoaded) {
        return <div>{t('detectord.loading')}</div>;
    } else {
        return (

            <div>
                {loadStatistics()}
            </div>
        );
    }
}

export default ParkingErrors;

